import React from 'react'
import SettingSeoForm from '../components/setting/SettingGoogleForm'

const SettingsGoogleApi = () => {
    return (
        <>
            <SettingSeoForm />
        </>
    )
}

export default SettingsGoogleApi